import React, {useState, useEffect, useRef} from 'react';
import { useParams, generatePath } from "react-router";
import { useHistory } from 'react-router-dom';
import routes from 'globals/routes';

import { useDataValue } from 'globals/contexts/dataContext';

import scrollingTo from 'utils/scrollingTo';
import ProjectWrapper from 'components/projectWrapper';

import './projectListSection.css';
import './projectListSectionMobile.css';

const ProjectListSection = (props) => {
  const pageContent = props['content'];
  // https://dev.to/finallynero/hooks-introduced-in-react-router-v5-1-7g8
  const { filter: presetFilter = null } = useParams();
  const [selectedFilter, setSelectedFilter] = useState(presetFilter);
  const [{currentPage, currentLanguage}] = useDataValue();
  const filterWrapper = useRef();
  const history = useHistory();
  const onProjectClick = (projectId) => {
    history.push(generatePath(routes.commercialProjectPage, {
      project: projectId,
      lang: currentLanguage
    }));
  }
  const typeToName = {};
  pageContent['filter'].forEach(filter => {
    typeToName[filter['type']] = filter['text'];
  });
  useEffect(() => {
    if (selectedFilter) {
      scrollingTo(filterWrapper.current);
    }
  }, [selectedFilter])
  return <section className="projectList" id="projectList">
    <div className="filterWrapper" ref={filterWrapper}>
      <div className="label">{pageContent['filterLabel']}</div>
      <div className="filters">
        {pageContent['filter'].map(item => {
          return <div key={item['type']}
            className={`filter${selectedFilter === item['type']? " selected": ""}`}
            onClick={() => {
              const newFilter = selectedFilter === item['type']? null: item['type'];
              history.replace(routes.pageWithLangAndFilter(currentPage, currentLanguage, newFilter));
              setSelectedFilter(
                newFilter
              );
            }}
          >
            <div className="styleIcon">
              <img src={item['icon']} />
            </div>
            <div className="name">
              <div className="line1">{item['text']}</div>
              <div className="line2">{item['text2']}</div>
            </div>
          </div>
        })}
      </div>
    </div>
    <ProjectWrapper items={pageContent['items']} selectedFilter={selectedFilter} 
      // colOffestTop={[0, 100]}
      onProjectClick={onProjectClick}
      ProjectInfoRenderer = {({project}) => {
        {/* console.log(`ProjectInfoRenderer - ${project['name']}`); */}
        return <div className="projectInfo">
          <div className="name">{project['name']}</div>
          <div className="line" />
          <div className="type">{typeToName[project['type']]}</div>
        </div>;
      }}
      typeToName={typeToName} />
  </section>;
}

export default ProjectListSection;